/* eslint-disable */
import { ref } from '@vue/composition-api'

export default function () {
    const showCollapse = ref(false)

    const toggleCollapse = () => {
        showCollapse.value = !showCollapse.value
    }

    return {
        showCollapse, 
        toggleCollapse
    }
}
